import React, { type FC } from 'react'
import { TableCell, TableRow } from '@mui/material'

import { assert } from '../../../../utils'

import { ConnectwareError, ConnectwareErrorType, Translation } from '../../../../domain'

import { ErrorDetails } from '../../ErrorMessage'
import { FormattedTranslation } from '../../Internationalization'
import { UpdateIcon } from '../Branding'
import { Button } from '../Button'
import { StateBlock } from '../StateBlock'
import { stateBlockCellStyle } from './Empty'
import { useColspan, useError } from './State'

export const ErrorTableBody: FC = () => {
    const colSpan = useColspan()
    const tableError = useError()
    assert(tableError, new ConnectwareError(ConnectwareErrorType.STATE, 'The error body is rendered without an error'))

    const { error, onRetry } = tableError

    return (
        <TableRow data-testid="error-table-body">
            <TableCell colSpan={colSpan} sx={stateBlockCellStyle}>
                <StateBlock
                    variant="error"
                    title={<FormattedTranslation id={Translation.TABLE_LOAD_ERROR} />}
                    actions={
                        <>
                            {onRetry && (
                                <Button data-testid="table-try-again" variant="secondary" size="medium" startIcon={<UpdateIcon />} onClick={onRetry}>
                                    <FormattedTranslation id={Translation.TRY_AGAIN} />
                                </Button>
                            )}
                            <ErrorDetails error={error} />
                        </>
                    }
                >
                    {error.message}
                </StateBlock>
            </TableCell>
        </TableRow>
    )
}
